import axios from 'axios';

const API_URL = '/api/products'; // Assicurati che l'URL sia corretto

// Recupera tutti i prodotti (pubblico, per il catalogo)
const getPublicProducts = async () => {
  const response = await axios.get(`${API_URL}/public`);
  return response.data;
};

// Recupera tutti i prodotti (protetto, per l'admin)
const getProtectedProducts = async (token) => {
  const response = await axios.get(API_URL, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// Crea un nuovo prodotto utilizzando un oggetto JSON
const createProduct = async (productData, token) => {
  const response = await axios.post(API_URL, productData, {
    headers: {
      'Content-Type': 'application/json', // Assicurati che l'header sia JSON
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// Aggiorna un prodotto esistente utilizzando un oggetto JSON
const updateProduct = async (id, productData, token) => {
  const safeId = encodeURIComponent(String(id));
  const response = await axios.put(`${API_URL}/${safeId}`, productData, {
    headers: {
      'Content-Type': 'application/json', // Assicurati che l'header sia JSON
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// Elimina un prodotto (richiede token)
const deleteProduct = async (id, token) => {
  const safeId = encodeURIComponent(String(id));
  const response = await axios.delete(`${API_URL}/${safeId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const productService = {
  getPublicProducts,
  getProtectedProducts,
  createProduct, // Aggiornato per inviare JSON
  updateProduct, // Aggiornato per inviare JSON
  deleteProduct,
};

export default productService;
